// Passe à true la première fois que l'élément entre à l'écran, puis ne bouge
// plus : les aperçus jouent leur animation une seule fois. Avec le mouvement
// réduit, vaut true tout de suite (l'aperçu s'affiche dans son état final).
import { useEffect, useRef, useState } from "react";

const mouvementReduit = () =>
	typeof window !== "undefined" &&
	typeof window.matchMedia === "function" &&
	window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export default function useApparition(seuil = 0.3) {
	const ref = useRef(null);
	const [visible, setVisible] = useState(mouvementReduit);

	useEffect(() => {
		if (visible) return undefined;
		const element = ref.current;
		if (!element || typeof IntersectionObserver === "undefined") {
			setVisible(true);
			return undefined;
		}
		const observateur = new IntersectionObserver(
			([entree]) => {
				if (entree.isIntersecting) {
					setVisible(true);
					observateur.disconnect();
				}
			},
			{ threshold: seuil }
		);
		observateur.observe(element);
		return () => observateur.disconnect();
	}, [visible, seuil]);

	return [ref, visible];
}
